import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {ProjectCareSubRegimeFields} from '@/features/projects/components/project-form/project-care-fields/ProjectCareSubRegimeFields'
import {ProjectRehabCareCommitmentData} from '@/features/projects/components/project-form/project-care-fields/ProjectRehabCareCommitmentData'
import {ProjectExpirationDateFields} from '@/features/projects/components/project-form/project-expiration-date-fields/ProjectExpirationDateFields'
import {ProjectSectorField} from '@/features/projects/components/project-form/project-sector-field/ProjectSectorField'
import {ProjectSiarFields} from '@/features/projects/components/project-form/project-siar-fields/ProjectSiarFields'
import {ProjectStartDateField} from '@/features/projects/components/project-form/project-start-date-field/ProjectStartDateField'
import {ProjectTransformHelpText} from '@/features/projects/components/project-transform-help-text/ProjectTransformHelpText'
import {ProjectEditingOperation} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'

export const ProjectFormNewProjectSection = ({editingOperation}: {editingOperation: ProjectEditingOperation}) => {
    const {t} = useTranslation()

    const renderTransformVariationResumeFields = () => (
        <Grid columns={3} rowGap={6} fullWidth>
            {editingOperation == 'transform' && (
                <GridItem spanColumn={6}>
                    <ProjectTransformHelpText />
                </GridItem>
            )}
            <GridItem spanColumn={2}>
                <ProjectSiarFields />
            </GridItem>
        </Grid>
    )

    const renderGenericFields = () => {
        return (
            <>
                <ProjectSectorField />
                <Grid columns={3} gap={4} fullWidth>
                    <ProjectCareSubRegimeFields />
                    <ProjectRehabCareCommitmentData />
                </Grid>
                <Grid columns={3} gap={4} fullWidth>
                    <ProjectStartDateField />
                </Grid>
                <ProjectExpirationDateFields />
                <Flexbox direction="column" gap={1.5}>
                    <Text palette="neutral" shade="500" size="textSm" weight="500">
                        {t('commons:welfare_system')}
                    </Text>
                    <Text size="textSm" weight="500">
                        {t('projects:non_residential')}
                    </Text>
                </Flexbox>
            </>
        )
    }

    return (
        <FormSection title={t('projects:new_project')}>
            <Flexbox direction="column" gap={6} fullWidth>
                {editingOperation != 'renew' && renderTransformVariationResumeFields()}
                {renderGenericFields()}
            </Flexbox>
        </FormSection>
    )
}
